<template>
  <div class="klickbox-step-description" style="margin-top: -11px;">
    <div class="klickbox-edit-title">
      {{ $t('general.labels.description') }}
      <description-checkbox></description-checkbox>
    </div>
    <text-editor
      v-show="descriptionVisibility"
      :content="step.description_text"
      :change="changed"
      :placeholder="$t('edit.canvas.question_description_placeholder')"></text-editor>
    <span class="klickbox-step-bar"></span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DescriptionCheckbox from './config/DescriptionCheckbox.vue';
import TextEditor from 'src/components/general/TextEditor/Main';

export default {
  components: {
    DescriptionCheckbox,
    TextEditor,
  },
  props: [
    'step',
  ],
  computed: mapGetters({
    descriptionVisibility: 'stepDescriptionVisibility',
  }),
  methods: {
    changed(text) {
      this.$store.dispatch('stepUpdateDescriptionText', {
        event: { target: { value: text } },
        id: this.step.id,
      });
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** Description.vue?bddf1624
 **/